<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <span class="text-h5">
          My account
        </span>
      </template>
    </TopHeader>
    <v-row>
      <v-col cols="12" md="6" sm="12" class="mt-5">
        <v-card>
          <v-card-title>Change password</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="8" class="offset-1">
                <v-text-field
                  v-model="password.old"
                  :error-messages="passwordErrors.old"
                  outlined
                  label="Mot de passe actuel"
                  @blur="$v.password.old.$touch()"
                />
                <v-text-field
                  v-model="password.new"
                  :error-messages="passwordErrors.new"
                  outlined
                  label="Nouveau mot de passe"
                  @blur="$v.password.new.$touch()"
                />
                <v-text-field
                  v-model="password.newRepeat"
                  :error-messages="passwordErrors.newRepeat"
                  outlined
                  label="Confirmer le mot de passe"
                  @blur="$v.password.newRepeat.$touch()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="offset-3">
                <v-btn
                  depressed
                  color="primary--text"
                  block
                  @click="changePassword"
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TopHeader from "@/components/base/TopHeader.vue"
import _ from "lodash"
import { AccountService } from "@/services"
import { required, sameAs, minLength } from "vuelidate/lib/validators"
import { validationMixin } from "vuelidate"
export default {
  components: {
    TopHeader
  },
  mixins: [validationMixin],
  validations: {
    password: {
      old: { required },
      new: { required, minLength: minLength(6) },
      newRepeat: {
        required,
        sameAsNew: sameAs(function() {
          return this.password.new
        })
      }
    },
    profile: { username: { required } },
    validationGroup: ["password", "profile"]
  },
  data() {
    return {
      loading: false,

      profileCopy: {
        email: "",
        first_name: "",
        last_name: "",
        username: ""
      },
      profile: {
        email: "",
        first_name: "",
        last_name: "",
        username: ""
      },
      password: {
        old: "",
        new: "",
        newRepeat: ""
      }
    }
  },
  computed: {
    profileInfoErrors() {
      const $ = this
      const errs = {
        username: []
      }
      if ($.$v.profile.username.$dirty) {
        !$.$v.profile.username.required &&
          errs.username.push("Le nom d'utilisateur est requis.")
      }
      return errs
    },
    passwordErrors() {
      const $ = this
      const errs = {
        old: [],
        new: [],
        newRepeat: []
      }
      if ($.$v.password.old.$dirty) {
        !$.$v.password.old.required &&
          errs.old.push("Ancien mot de passe est requis")
      }
      if ($.$v.password.new.$dirty) {
        !$.$v.password.new.required &&
          errs.new.push("Nouveau mot de passe est requis")
        !$.$v.password.new.minLength &&
          errs.new.push(
            "Longueur minimale du mot de passe doit être respectée (6 caractères)"
          )
      }
      if ($.$v.password.newRepeat.$dirty) {
        if (!$.$v.password.newRepeat.required)
          errs.newRepeat.push("La répétition du mot de passe est requise")
        if (!$.$v.password.newRepeat.sameAsNew)
          errs.newRepeat.push(
            "Le mot de passe doit être identique au nouveau mot de passe"
          )
      }
      return errs
    },
    hasChanged() {
      return JSON.stringify(this.profileCopy) !== JSON.stringify(this.profile)
    }
  },
  created() {
    var t = this
    this.loading = true

    AccountService.profile(this).then(function(response) {
      t.profile = response
      t.profileCopy = _.cloneDeep(response)
    })
    t.loading = false
  },
  methods: {
    updateProfileInfo() {
      const t = this
      t.$v.profile.$touch()
      if (!t.$v.profile.$invalid) {
        AccountService.updateProfileInfo(
          this,
          this.profile.first_name,
          this.profile.last_name,
          this.profile.username
        ).then(r => {
          t.profileCopy = _.cloneDeep(t.profile)
        })
      }
    },
    changePassword() {
      const $ = this
      $.$v.password.$touch()
      if (!$.$v.password.$invalid) {
        AccountService.changePassword(
          $,
          $.password.old,
          $.password.new,
          $.password.newRepeat
        ).then(r => {})
      }
    }
  }
}
</script>
